import { useQuery } from 'react-query';

import { faultQueryKeys } from '../QueryKeys';
import useApiHelper from '../../hooks/useApiHelper';
import { IFaultCause } from '../../types/Fault/FaultCause';
import stubFaultCauses from '../../stubs/FaultCause.json';
import { IDefaultResponseWithData } from '../../types/system/DefaultResponse';

export default function useFaultCause(id: string) {
  const { get } = useApiHelper();

  const faultCause = useQuery({
    queryKey: faultQueryKeys.cause(id),
    // queryFn: () =>
    // Return stub data wrapped in a promise to simulate async behavior
    // Promise.resolve(stubFaultCauses.find(cause => cause.id === id) as unknown as IFaultCause),

    // Uncomment below when API is ready:
    queryFn: () =>
      get<IDefaultResponseWithData<IFaultCause>>(`/v1/fault/causes/${id}`).then(
        (res) => res.data.data
      ),
    enabled: !!id,
  });

  return {
    faultCause,
  };
}
